// Includes server-backed types matching the OWS ActivityType enum and client-only types.
// https://outlookweb.visualstudio.com/Outlook%20Web/_git/server-ows-api?path=/src/Microsoft.OWS.ActivityFeed/Models/ActivityType.cs
export enum ActivityType {
    Unknown = "Unknown",
    Like = "Like",
    AtMention = "AtMention",
    GroupMention = "GroupMention",
    MeMention = "MeMention",
    FileMention = "FileMention",
    GroupAtAllMention = "GroupAtAllMention",
    UserAtMentioned = "UserAtMentioned",
    Reactions = "Reactions",
    CommentCreated = "CommentCreated",
    TaskCreated = "TaskCreated",
    TaskCompleted = "TaskCompleted",
    TaskReassigned = "TaskReassigned",
    TaskReopened = "TaskReopened",
    PromptAction = "PromptAction",
    ManagedEventNotification = "ManagedEventNotification",
    CalendarInstructionNotification = "CalendarInstructionNotification",
    // Client-only scheduling tasks stored in IndexedDB; not part of the OWS contract.
    SchedulingDraftNotification = "SchedulingDraftNotification"
}

export enum ActivityFeedItemSource {
    Server = "Server",
    IndexedDb = "IndexedDb",
    Client = "Client"
}

// ActivityStateFlags are defined in server-ows-api. Please keep in sync with
// https://outlookweb.visualstudio.com/Outlook%20Web/_git/server-ows-api?
// path=%2Fsrc%2FMicrosoft.OWS.ActivityFeed%2FModels%2FActivityStateFlags.cs
export enum ActivityStateFlags {
    /// No flags
    None = 0,
    /// Activity Feed Item is marked as dismissed.
    /// Set when the user has explicitly dismisses the Activity Feed Item.
    IsDismissed = 1 << 0,
    /// Activity Feed Item is marked as seen.
    /// Set when the Activity Feed Item has been shown to the user.
    IsSeen = 1 << 1,
    /// Activity Feed Item is marked as read.
    /// Set when the user has explicitly clicks the Activity Feed Item.
    IsRead = 1 << 2,
    // Activity Feed Item is marked as completed.
    IsCompleted = 1 << 3,
    /// Activity Feed Item is marked as important.
    IsFlagged = 1 << 4
}

export interface ActivityFeedV2StorageItem {
    id: string;
    type: ActivityType;
    collectionId: string;
    activityState: ActivityStateFlags;
    activityFeedItemPayload: string;
    timestamp: string;
    source?: ActivityFeedItemSource;
}

export interface ActivityFeedV1StorageItem {
    id: string;
    type: ActivityType;
    isSeen: boolean;
    isRead: boolean;
    isDismissed: boolean;
    activityFeedItemPayload: string;
    timestamp: string;
    source?: ActivityFeedItemSource;
}

export type ActivityFeedStorageItem = ActivityFeedV1StorageItem | ActivityFeedV2StorageItem;
